import React, { createContext, useContext, useEffect, useState } from 'react'
import {
  getPeriodoFromLastXDays,
  getPeriodoMesAtual,
  getPeriodoUltimos30Dias,
} from '../services/util/date.service'

const EntregaContext = createContext()

const { pInicial: envioParaRotaInicial, pFinal: envioParaRotaFinal } = getPeriodoFromLastXDays(
  31,
  7,
)

const INITIAL_STATE = {
  cicloEntrega: {
    selectedPeriodo: getPeriodoMesAtual(),
    selectedCentral: '',
    globalFilter: '',
  },
  entregasPorEmpresa: {
    selectedPeriodo: getPeriodoMesAtual(),
    selectedEmpresa: '',
  },
  gestaoCanhotos: {
    selectedPeriodo: getPeriodoMesAtual(),
    principal: null,
    comCanhoto: null,
  },
  historicoVeiculoRetornado: {
    selectedPeriodo: getPeriodoMesAtual(),
    selectedVeiculo: '',
    notaFiscal: '',
  },
  retornoVeiculo: {
    selectedPeriodo: getPeriodoUltimos30Dias(),
    notaFiscal: '',
    cidade: '',
    selectedEmpresas: [],
  },
  envioParaRota: {
    selectedPeriodo: {
      dataInicial: envioParaRotaInicial,
      dataFinal: envioParaRotaFinal,
    },
    notaFiscal: '',
    cidade: '',
    selectedEmpresas: [],
  },
  mapaCarga: {
    selectedPeriodo: {
      dataInicial: envioParaRotaInicial,
      dataFinal: envioParaRotaFinal,
    },
  },
  mapaCargaAnalitica: {
    selectedPeriodo: {
      dataInicial: envioParaRotaInicial,
      dataFinal: envioParaRotaFinal,
    },
  },
  justificativaCargasParadas: {
    selectedPeriodo: getPeriodoUltimos30Dias(),
    selectedCompany: null,
    identifier: '',
  },
  carregamentoVeiculo: {
    selectedPeriodo: getPeriodoUltimos30Dias(),
    rowsPerPage: 10,
  },
}

export const EntregaContextProvider = ({ children }) => {
  const [entregaContext, setEntregaContext] = useState(INITIAL_STATE)
  const [cicloEntregaContext, setCicloEntregaContext] = useState(entregaContext.cicloEntrega)
  const [entregasPorEmpresaContext, setEntregasPorEmpresaContext] = useState(
    entregaContext.entregasPorEmpresa,
  )
  const [gestaoCanhotoContext, setGestaoCanhotoContext] = useState(entregaContext.gestaoCanhotos)
  const [historicoVeiculoRetornadoContext, setHistoricoVeiculoRetornadoContext] = useState(
    entregaContext.historicoVeiculoRetornado,
  )
  const [retornoVeiculoContext, setRetornoVeiculoContext] = useState(entregaContext.retornoVeiculo)
  const [envioParaRotaContext, setEnvioParaRotaContext] = useState(entregaContext.envioParaRota)
  const [mapaCargaContext, setMapaCargaContext] = useState(entregaContext.mapaCarga)
  const [mapaCargaAnaliticaContext, setMapaCargaAnaliticaContext] = useState(
    entregaContext.mapaCargaAnalitica,
  )
  const [justificativaCargasParadasContext, setJustificativaCargasParadasContext] = useState(
    entregaContext.justificativaCargasParadas,
  )
  const [carregamentoVeiculoContext, setCarregamentoVeiculoContext] = useState(
    entregaContext.carregamentoVeiculo,
  )

  return (
    <EntregaContext.Provider
      value={{
        entregaContext,
        setEntregaContext,
        cicloEntregaContext,
        setCicloEntregaContext,
        entregasPorEmpresaContext,
        setEntregasPorEmpresaContext,
        gestaoCanhotoContext,
        setGestaoCanhotoContext,
        historicoVeiculoRetornadoContext,
        setHistoricoVeiculoRetornadoContext,
        retornoVeiculoContext,
        setRetornoVeiculoContext,
        envioParaRotaContext,
        setEnvioParaRotaContext,
        mapaCargaContext,
        setMapaCargaContext,
        mapaCargaAnaliticaContext,
        setMapaCargaAnaliticaContext,
        justificativaCargasParadasContext,
        setJustificativaCargasParadasContext,
        carregamentoVeiculoContext,
        setCarregamentoVeiculoContext,
      }}
    >
      {children}
    </EntregaContext.Provider>
  )
}

export const useEntregaContext = () => {
  const { entregaContext, setEntregaContext } = useContext(EntregaContext)
  return { entregaContext, setEntregaContext }
}

export const useCicloEntregaContext = () => {
  const { setEntregaContext } = useContext(EntregaContext)
  const { cicloEntregaContext, setCicloEntregaContext } = useContext(EntregaContext)

  useEffect(() => {
    setEntregaContext(prevEntregaContext => ({
      ...prevEntregaContext,
      cicloEntrega: cicloEntregaContext,
    }))
  }, [cicloEntregaContext])

  return { cicloEntregaContext, setCicloEntregaContext }
}

export const useEntregasPorEmpresaContext = () => {
  const { setEntregaContext } = useContext(EntregaContext)
  const { entregasPorEmpresaContext, setEntregasPorEmpresaContext } = useContext(EntregaContext)

  useEffect(() => {
    setEntregaContext(prevEntregaContext => ({
      ...prevEntregaContext,
      entregasPorEmpresa: entregasPorEmpresaContext,
    }))
  }, [entregasPorEmpresaContext])

  return { entregasPorEmpresaContext, setEntregasPorEmpresaContext }
}

export const useGestaoCanhotoContext = () => {
  const { setEntregaContext } = useContext(EntregaContext)
  const { gestaoCanhotoContext, setGestaoCanhotoContext } = useContext(EntregaContext)

  useEffect(() => {
    setEntregaContext(prevEntregaContext => ({
      ...prevEntregaContext,
      gestaoCanhoto: gestaoCanhotoContext,
    }))
  }, [gestaoCanhotoContext])

  return { gestaoCanhotoContext, setGestaoCanhotoContext }
}

export const useHistoricoVeiculoRetornadoContext = () => {
  const { setEntregaContext } = useContext(EntregaContext)
  const { historicoVeiculoRetornadoContext, setHistoricoVeiculoRetornadoContext } =
    useContext(EntregaContext)

  useEffect(() => {
    setEntregaContext(prevEntregaContext => ({
      ...prevEntregaContext,
      historicoVeiculoRetornado: historicoVeiculoRetornadoContext,
    }))
  }, [historicoVeiculoRetornadoContext])

  return { historicoVeiculoRetornadoContext, setHistoricoVeiculoRetornadoContext }
}

export const useRetornoVeiculoContext = () => {
  const { setEntregaContext } = useContext(EntregaContext)
  const { retornoVeiculoContext, setRetornoVeiculoContext } = useContext(EntregaContext)

  useEffect(() => {
    setEntregaContext(prevEntregaContext => ({
      ...prevEntregaContext,
      retornoVeiculo: retornoVeiculoContext,
    }))
  }, [retornoVeiculoContext])

  return { retornoVeiculoContext, setRetornoVeiculoContext }
}

export const useEnvioParaRotaContext = () => {
  const { setEntregaContext } = useContext(EntregaContext)
  const { envioParaRotaContext, setEnvioParaRotaContext } = useContext(EntregaContext)

  useEffect(() => {
    setEntregaContext(prevEntregaContext => ({
      ...prevEntregaContext,
      envioParaRota: envioParaRotaContext,
    }))
  }, [envioParaRotaContext])

  return { envioParaRotaContext, setEnvioParaRotaContext }
}

export const useMapaCargaContext = () => {
  const { setEntregaContext } = useContext(EntregaContext)
  const { mapaCargaContext, setMapaCargaContext } = useContext(EntregaContext)

  useEffect(() => {
    setEntregaContext(prevEntregaContext => ({
      ...prevEntregaContext,
      mapaCarga: mapaCargaContext,
    }))
  }, [mapaCargaContext])

  return { mapaCargaContext, setMapaCargaContext }
}

export const useMapaCargaAnaliticaContext = () => {
  const { setEntregaContext } = useContext(EntregaContext)
  const { mapaCargaAnaliticaContext, setMapaCargaAnaliticaContext } = useContext(EntregaContext)

  useEffect(() => {
    setEntregaContext(prevEntregaContext => ({
      ...prevEntregaContext,
      mapaCargaAnalitica: mapaCargaAnaliticaContext,
    }))
  }, [mapaCargaAnaliticaContext])

  return { mapaCargaAnaliticaContext, setMapaCargaAnaliticaContext }
}

export const useJustificativaCargasParadasContext = () => {
  const { setEntregaContext } = useContext(EntregaContext)
  const { justificativaCargasParadasContext, setJustificativaCargasParadasContext } =
    useContext(EntregaContext)

  useEffect(() => {
    setEntregaContext(prevEntregaContext => ({
      ...prevEntregaContext,
      justificativaCargasParadas: justificativaCargasParadasContext,
    }))
  }, [justificativaCargasParadasContext])

  return { justificativaCargasParadasContext, setJustificativaCargasParadasContext }
}

export const useCarregamentoVeiculoContext = () => {
  const { setEntregaContext } = useContext(EntregaContext)
  const { carregamentoVeiculoContext, setCarregamentoVeiculoContext } = useContext(EntregaContext)

  useEffect(() => {
    setEntregaContext(prevEntregaContext => ({
      ...prevEntregaContext,
      carregamentoVeiculo: carregamentoVeiculoContext,
    }))
  }, [carregamentoVeiculoContext])

  return { carregamentoVeiculoContext, setCarregamentoVeiculoContext }
}
